<script lang="ts" setup>
// -------------------------------
// 🔹 Imports Vue & composables
// -------------------------------
import { isLoaderLoginFormActivated } from '../../refs/login.form.refs';
import { isCategoryActivated } from '@/refs/categories.refs';

// -------------------------------
// 🔹 Composants
// -------------------------------
import TextInput from '../common/BaseInput.vue';
import BaseButtonPrimary from '../common/BaseButtonPrimary.vue';

// -------------------------------
// 🔹 Refs & données
// -------------------------------
import { idToDelete } from '@/refs/commerce.refs';
import { isGlobalError } from '@/refs/common.refs';

// -------------------------------
// 🔹 Mutations / services
// -------------------------------
import { UserMutation } from '@/mutations/user.mutation';
import { form_Client_user_Body, isAtcivatedWatch } from '@/refs/user.refs';
const { handleUpdateUserCustomerById, handleDeleteUserClientCustomer } =
  UserMutation();

// -------------------------------
// 🔹 Émission d’événements
// -------------------------------
const emit = defineEmits<{
  (e: 'HandleClose'): void;
}>();

// -------------------------------
// 🔹 Gestion du formulaire
// -------------------------------

/**
 * Soumet le formulaire de création de commerce.
 * Gère les différentes étapes : création du commerce, ajout du contact, ou upload du logo.
 */
const handleSubmit = async () => {
  isLoaderLoginFormActivated.value = true;

  try {
    const res = await handleUpdateUserCustomerById({
      firstname: form_Client_user_Body.firstname,
      lastname: form_Client_user_Body.lastname,
    });

    if (res) {
      setTimeout(() => {
        isAtcivatedWatch.value = !isAtcivatedWatch.value;
        isLoaderLoginFormActivated.value = false;
        handleClose();
      }, 1000);
    }
  } catch (error) {
    isGlobalError.value = true;
    setTimeout(() => {
      isLoaderLoginFormActivated.value = false;
      isGlobalError.value = false;
    }, 1000);
  }
};

/**
 * Ferme le formulaire et réinitialise l’ID à supprimer.
 */
const handleClose = (): void => {
  idToDelete.value = null;
  emit('HandleClose');
};
</script>

<template>
  <form
    autocomplete="on"
    accept-charset="UTF-8"
    @submit.prevent="handleSubmit"
    class="space-y-6"
  >
    <div class="space-y-[16px]">
      <TextInput
        required="true"
        v-model="form_Client_user_Body.firstname"
        name="Entrez le nom du client"
        placeholder="Entrez le nom du client"
        type="text"
        id="Entrez le nom du client"
        label="Entrez le nom du client"
      />

      <TextInput
        required="true"
        v-model="form_Client_user_Body.lastname"
        name="Entrez le prénom du client"
        placeholder="Entrez le prénom du client"
        type="text"
        id="Entrez le prénom du client"
        label="Entrez le prénom du client"
      />
    </div>

    <div class="invisible h-[50px]" />

    <div class="fixed bottom-0 left-0 w-full bg-white py-6">
      <div class="flex flex-row items-center justify-between gap-8 px-[16px]">
        <div class="w-full">
          <BaseButtonPrimary
            type="submit"
            :isClicked="isLoaderLoginFormActivated"
            :label="isCategoryActivated ? 'Modifier' : 'Enregistrer'"
            style_of_btn="primary_color_of_btn "
            class="w-full text-white"
          />
        </div>

        <div class="w-full" @click="handleClose">
          <BaseButtonPrimary
            type="button"
            label="Annuler"
            style_of_btn="secondary_color_of_btn "
            class="text-grand-text w-full"
          />
        </div>
      </div>
    </div>
  </form>
</template>
